import React from 'react'
import '../../assets/css/Search.css'
import Grid from "@material-ui/core/Grid";
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import SearchIcon from '@material-ui/icons/Search';
import axios from "axios";
import GridContainer from "../Grid/GridContainer.jsx";
import { toast } from 'react-toastify';
import { BASE_URL } from '../../utils/handleApi';

const useStyles = (theme) => ({

    margin: {
        // margin: theme.spacing(1),
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(1)
    },
    marginss: {
        margin: theme.spacing(1),
        marginTop: theme.spacing(2.5),
        // marginLeft: theme.spacing(1.5),
        // borderRadius:
        // backgroundColor:'yellow',
        height: '3px',
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: 'transparent',
                boxShadow: '0px 0px 5px 0px #d6d6d6',
                borderRadius: 1,
                // height:'3px',
                // backgroundColor:'red',
                // paddingBottom: theme.spacing(5)
            },
            '&:hover fieldset': {
                borderColor: 'transparent',
                boxShadow: '0px 0px 5px 0px #d6d6d6',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#04AB23',
                // boxShadow: '0px 0px 5px 0px #d6d6d6',
            },

        },


    },
    button: {
        margin: theme.spacing(1.9),
        marginTop: theme.spacing(2.5),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(0),
        color: 'white',
        backgroundColor: '#04AB23',
        textTransform: 'none',
        fontFamily: 'Roboto-Medium',
        boxShadow: "none",
        borderRadius: 1,
        height: '36px',
        width:'100px',
        '&:hover': {
            backgroundColor: '#04AB23'
        },
        '&:focus': {
            outline: 'none'
        },

    },
    textSearch: {
        fontSize: '22px',
        fontFamily: 'Roboto-Light',
        color: '#333333',
        [theme.breakpoints.down('sm')]: {
            fontSize: '23.5px',
            marginTop: theme.spacing(3)
        },
    },
    textOrderLookup: {
        fontSize: '22px',
        fontFamily: 'Roboto-Light',
        color: '#333333',
        [theme.breakpoints.down('sm')]: {
            fontSize: '20px',
            // marginTop: theme.spacing(-0.1)
        },
    },
    parent:{
      width:'97.8%',
      marginLeft:'auto',
      marginRight:'auto',
      [theme.breakpoints.down('md')]: {
        width:'95%',
    },
    [theme.breakpoints.down('sm')]: {
        width:'90%',
    },
    }
});
class Search extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: '',
            order: [],
        };
    }

    handleChange = (event) => {
        this.setState({ data: event.target.value });
    };

    getOrder = () => {
        const tokenStr = localStorage.getItem('token')
        const options = {
            headers: {
                'Authorization': `Bearer ${tokenStr}` 
            }
        };
        axios.post(`${BASE_URL}/order/logs`, 
        { order_no: this.state.data }, options)
        .then((res) => {
            this.setState({ order: res.data.details}, () => {
                this.props.order_no(this.state.order);
            })
        })
        .catch((err) => {
            if(err.response.status === 500){
                return toast.error('Please enter valid Order No.')
            }
            toast.error("Some Error Happened")
        })
      }

    render() {
        const { classes } = this.props
        return (
            <div className={classes.parent}>
                <GridContainer>
                    <Grid item xs={12} sm={12} md={6}>
                        <div style={{ display: 'flex' }}>
                            {/* <h3 className={classes.textOrderLookup}>
                                
                            </h3> */}
                            <form className={classes.marginss} noValidate autoComplete="off">
                                <TextField 
                                    id="outlined-basic"
                                    variant="outlined" 
                                    size="small"
                                    onChange={this.handleChange}
                                    value={this.state.data}
                                    placeholder="Enter Order No."
                                />
                            </form>
                            <Button 
                                onClick={this.getOrder}
                                variant="contained"
                                className={classes.button}
                                endIcon={<SearchIcon />}
                                size="small"
                            >
                                Search
                            </Button>
                        </div>
                    </Grid>
                </GridContainer>

            </div>
        )
    }

}
export default withStyles(useStyles, { withTheme: true })(Search)